import React, { Component } from 'react';
import moment from 'moment-jalaali';
import { requestState } from "../../constants/enum.constants";
import BSelectInput from "../../helpers/bselect-input";
import Select from 'react-select';
import CertRequestServiceModel from "../../models/certrequestservice";
import { dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";
import { paymentState,paymentType } from "../../constants/enum.constants";
import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';
import  CertReqPaymentModal  from "../modal/certreqpaymentmodal";
import { thisTypeAnnotation } from '@babel/types';


function nestadDataFormatterPlus(cell, row,field)
{
    
    if( row.CertificationTariffCity==null ){
        return cell!=null ? cell[field]:'';
    }else{
        return row.CertificationTariffCity.Price
    }
   
}

function buttonFormatter(cell, row,extra) {
    return (
        <div>
        
            <div>
                
                <button className="btn btn-primary btn-md" onClick={()=> extra.openModal(row)}>پرداخت</button>
                {(row.PanoPaymentUrl!=null) ?

                    <a href={`${row.PanoPaymentUrl}`} target="_blank" className="btn btn-default btn-md">درگاه</a>:""
                } 
            </div>
        
        </div>
    );
}

class CertReqPaymentPartial extends Component {
    constructor(props) {
        super(props);
        
     
    }


    componentWillReceiveProps(newProps)
    {
       
    }
    
    render() { 


        const {model} = this.props;
        

        console.log('_MODEL',model) 
        return (  

            <div>
                <CertReqPaymentModal {...this.props} ref="paymentModal"></CertReqPaymentModal>                    
                <div className="row">
                    <div className="col-md-12">
                   
                    <BootstrapTable data={model && model.CertificationPayments}  striped hover
                        headerContainerClass='rightAlignStyle'
                        bodyContainerClass='rightAlignStyle'>

                        <TableHeaderColumn  isKey dataField='Id' hidden >id</TableHeaderColumn>  
                        <TableHeaderColumn dataField='CertificationType' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >عنوان</TableHeaderColumn>                                 
                        <TableHeaderColumn dataField='CertificationTariff' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >تعرفه</TableHeaderColumn>                        
                        <TableHeaderColumn dataField='CertificationTariff' formatExtraData="Price" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatterPlus }  >هزینه</TableHeaderColumn>
                        <TableHeaderColumn dataField='PaymentValue' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}}  >قابل پرداخت</TableHeaderColumn>
                        <TableHeaderColumn dataField='PaymentType' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ enumDataFormatter } formatExtraData={ paymentType} >نوع پرداخت</TableHeaderColumn>
                        <TableHeaderColumn dataField='PaymentState' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ enumDataFormatter } formatExtraData={ paymentState} >وضعیت</TableHeaderColumn>
                        <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter } formatExtraData={ this.refs.paymentModal}></TableHeaderColumn>
                                             
                    </BootstrapTable>
                    </div>           
                </div>

            </div>
  
        );
    }
}
 
export default CertReqPaymentPartial;